import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpResponse } from '../interfaces/http.response';
import { Observable } from 'rxjs';
import { EnvConfigService } from './env-config.service';

@Injectable({
  providedIn: 'root',
})
export class RequestBuilderService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(EnvConfigService);

  post(path: string, payload: any): Observable<HttpResponse> {
    return this.http.post<HttpResponse>(`${this.env.getConfig().apiUrl}/${path}`, payload);
  }
  put(path: string, payload: any): Observable<HttpResponse> {
    return this.http.put<HttpResponse>(`${this.env.getConfig().apiUrl}/${path}`, payload);
  }
  patch(path: string, payload: any): Observable<HttpResponse> {
    return this.http.patch<HttpResponse>(`${this.env.getConfig().apiUrl}/${path}`, payload);
  }
  delete(path: string): Observable<HttpResponse> {
    return this.http.delete<HttpResponse>(`${this.env.getConfig().apiUrl}/${path}`);
  }
  get(path: string) {
    return this.http.get<HttpResponse>(`${this.env.getConfig().apiUrl}/${path}`);
  }
}
